import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
export default {
  name: "pro-tree-app-detail",
  props: {
    treeData: {
      type: Array,
      default() {
        return [];
      }
    },
    multiple: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      search: {
        value: ""
      },
      checkTree: []
    };
  },
  computed: {
    data() {
      if (this.search.value) {
        return this.mapTree(this.search.value, this.treeData);
      } else {
        return this.treeData;
      }
    }
  },
  watch: {
    visible(val) {
      if (!val) {
        this.clean();
      }
    }
  },
  methods: {
    clean() {
      this.search.value = "";
    },
    mapTree(value, arr) {
      let newarr = [];
      arr.forEach(element => {
        if (element.title.indexOf(value) > -1) {
          // 判断条件
          element.expand = true;
          newarr.push(element);
        } else {
          if (element.children && element.children.length > 0) {
            let redata = this.mapTree(value, element.children);
            if (redata && redata.length > 0) {
              let obj = {
                ...element,
                expand: true,
                children: redata
              };
              newarr.push(obj);
            }
          }
        }
      });
      return newarr;
    },
    /*
     ** 设置图标
     */
    renderContent(h, {
      data
    }) {
      let styleCheck = {
        marginLeft: "5px",
        color: "#dddddd"
      };
      const titleRender = () => {
        if (this.search.value) {
          if (data.title.indexOf(this.search.value) > -1) {
            let arr = data.title.split(this.search.value);
            if (arr.length === 1) {
              // split: [xxx]
              return h("span", {
                "style": {
                  color: "red"
                }
              }, [this.search.value]);
            } else if (arr[0] && arr[1]) {
              // split: [xxx,xxx]
              return h("span", [arr[0], h("span", {
                "style": {
                  color: "red"
                }
              }, [this.search.value]), arr[1], "(", data.code, ")"]);
            } else if (arr[0]) {
              // split: [xxx, '']
              return h("span", [arr[0], h("span", {
                "style": {
                  color: "red"
                }
              }, [this.search.value]), "(", data.code, ")"]);
            } else {
              // split: ['', xxx]
              return h("span", [h("span", {
                "style": {
                  color: "red"
                }
              }, [this.search.value]), arr[1], "(", data.code, ")"]);
            }
          } else {
            return h("span", [data.title, "(", data.code, ")"]);
          }
        } else {
          return h("span", [data.title, "(", data.code, ")"]);
        }
      };
      return h("span", [titleRender(), data.webChecked ? h("Icon", {
        "style": {
          ...styleCheck
        },
        "attrs": {
          "color": "#3D7FFF",
          "type": "md-checkmark"
        }
      }) : ""]);
    },
    onSelectChangeTree(arr, item) {
      if (item.webChecked) {
        this.$Message.warning($t("egewi3", "已选择"));
        return;
      }

      // multiple：true代表多选
      if (!this.multiple) {
        let change = arr => {
          arr.forEach(v => {
            // 接口树可能没有预置 webChecked，使用 $set 保证左右选中状态同步。
            this.$set(v, "webChecked", false);
            let children = v.children;
            if (children && children.length > 0) {
              change(children);
            }
          });
        };
        change(this.treeData);
      }
      this.$set(item, "webChecked", true);
    }
  }
};